export const projects = [
  { name: 'Estudio Norte', stage: 4 },
  { name: 'Café Alma', stage: 2 },
  { name: 'Clínica Vértice', stage: 3 },
  { name: 'Lumen Fitness', stage: 1 },
]

export const teamInitials = ['LM', 'JR', 'SC']

export const channels = [
  { name: 'Instagram', value: 82 },
  { name: 'Web', value: 64 },
  { name: 'LinkedIn', value: 41 },
  { name: 'Email', value: 28 },
]

export const trendPoints: [number, number][] = [
  [0, 132],
  [40, 120],
  [80, 124],
  [120, 100],
  [160, 106],
  [200, 82],
  [240, 86],
  [280, 62],
  [320, 54],
  [360, 38],
  [400, 24],
]
